import {Component, Input, Output, inject} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import {BehaviorSubject, combineLatest, delay, Observable, of, Subject, switchMap, tap} from 'rxjs';
import {CrmDataService} from '../../crm-data.service';
import {map} from 'rxjs/operators';
import {debug} from '../../rxjs/debug';
import {BaseRxjsComponent} from '../BaseRxjsComponent';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import {applyFormlyTranslation} from '../../formly/apply-formly-translation';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'nbd-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, FormlyModule, MatButton, MatProgressBar, AsyncPipe, TranslatePipe]
})
export class FormComponent<T> extends BaseRxjsComponent {
  private crm = inject(CrmDataService);
  private ts = inject(TranslateService);


  form: FormGroup;
  formTemplate$?: Observable<FormlyFieldConfig[]>;

  additionalFields$ = new BehaviorSubject<FormlyFieldConfig[]>([]);
  formKey$ = new BehaviorSubject<string | null>(null);
  fieldChanges$ = new Subject<any>();

  @Input() item?: T | null;
  // @Input() options: FormlyFormOptions = {};
  options: FormlyFormOptions = {
    fieldChanges: this.fieldChanges$,
    formState: {
      disabled: false
    }
  };
  @Input() submitActionText = "common.save";
  @Input() showCancel = false;
  @Input() showSubmit = false;
  @Input() readonly = false;
  @Output() submit$ = new Subject<any>();
  @Output() cancel$ = new Subject<void>();

  constructor() {
    super();

    this.loading();
    // this.sub = this.fieldChanges$.pipe(
    //   tap(() => {
    //     this.readonly ? this.form.disable() : this.form.enable()
    //   })
    // ).subscribe();

    this.form = new FormGroup({});

    // this.options = {
    //   ...this.options,
    //   fieldChanges: this.fieldChanges$
    // }

    this.formTemplate$ = combineLatest([
      this.formKey$.pipe(
        switchMap((key) => {
          if (key) {
            return this.crm.getFormTemplate(key)
          }
          return of([]);
        }),
      ),
      this.additionalFields$,
    ]).pipe(
      debug('Templates'),
      // C11: bake the field labels via ts.instant only AFTER the i18n bundle is
      // loaded. The template arrives from getFormTemplate over HTTP; on a cold load
      // landing straight on a form (e.g. User detail) it can resolve before the
      // translations do, in which case ts.instant returns the raw keys and they get
      // frozen into the config (the pipe runs once). ts.get() waits for the active
      // language's translations to be present, so the labels resolve correctly.
      switchMap(([config, additionalConfig]) =>
        this.ts.get('common.save').pipe(
          map(() => {
            for (const c of config) {
              applyFormlyTranslation(c, this.ts);
            }
            for (const c of additionalConfig) {
              applyFormlyTranslation(c, this.ts);
            }
            return [...config, ...additionalConfig];
          })
        )
      ),
      delay(30),
      tap(() => this.loaded())
    );


  }

  @Input() set enabled(value: boolean) {
    this.options.formState.disabled = !value;
    // this.readonly = !value;
    //
    // if(value) {
    //   this.form.enable();
    // } else {
    //   this.form.disable();
    // }
  }

  @Input() set formKey(key: string | null) {
    this.formKey$.next(key);
  }

  @Input() set additionalFields(config: FormlyFieldConfig[]) {
    this.additionalFields$.next(config);
  }
}
